import Skeleton from '@mui/material/Skeleton';

import { graphql, ThirdPartyTypeEnum } from '@e-socna/data-layer';
import type { Id } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../hooks/useGraphQLQuery.hook';

export const ThirdParty_OneThirdPartyName_QueryDocument = graphql(`
  query ThirdParty_OneThirdPartyName_Query($id: Id!) {
    findOneThirdParty(id: $id) {
      _id
      __typename
      color
      ... on Person {
        fullName
      }
      ... on Organization {
        name
        tradingName
      }
    }
  }
`);

interface Props {
  readonly id: Id;
}

export const ThirdPartyName = ({ id }: Readonly<Props>) => {
  const { data, isSuccess } = useGraphQLQuery(
    ThirdParty_OneThirdPartyName_QueryDocument,
    { id },
    { enabled: !!id },
  );

  if (!isSuccess) {
    return (
      <Skeleton sx={{ display: 'inline-block' }} variant="text" width={210} />
    );
  }

  const thirdParty = data.findOneThirdParty;

  switch (thirdParty.__typename) {
    case 'Person':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Person: {
      const { fullName } = thirdParty;
      return fullName;
    }
    case 'Organization':
    // eslint-disable-next-line @typescript-eslint/no-unsafe-enum-comparison
    case ThirdPartyTypeEnum.Organization: {
      const { name } = thirdParty;
      return name;
    }
    default: {
      throw new Error('Unknown third party type');
    }
  }
};
